module.exports = __webpack_public_path__ + "img/cerro-rivera.ee2e54c5.jpg";